export default {
    levels_loaded: "vip.levels.loaded",
    loaded: "vip.loaded",
    history: {
        add: "vip.history.add"
    },
    profile: "vip.profile",
    toggleButton: "vip.toggle.button"
}